import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    assistances: [],
    assistance: {}
  },
  mutations: {
    index(state, payload) {
      state.assistances = payload
    },
    show(state, payload) {
      state.assistance = payload
    }
  },
  actions: {
    index({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/assistances${payload || ''}`).then((res) => {
        commit('index', res.data)
        return res.data;
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/assistances/${payload}`).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    },
    create({ commit }, payload) {
      return axios.post(`${ENV.API_URL}/api/assistances`, payload).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    },
    update({ commit }, payload) {
      return axios.put(`${ENV.API_URL}/api/assistances/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    },
    delete({ commit }, payload) {
      return axios.delete(`${ENV.API_URL}/api/assistances/${payload.id}`, payload).then((res) => {
        commit('remove', res.data)
        return res.data;
      })
    }
  },
  getters: {
    assistances: state => {
      return state.assistances
    },
    assistance: state => {
      return state.assistance
    }
  },
  modules: {}
}
